import {
  Card,
  Stack,
  Typography,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  TextField,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import Services from 'src/services/Services';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from 'react-toastify';

export default function EasyMall() {
  const parsedUser = JSON.parse(localStorage.getItem('user'));

  const [isMallActive, setMallActive] = useState(false);
  const [isProductsListed, setProductsListed] = useState(false);
  const [isConciergeActive, setConciergeActive] = useState(false);

  const [openMallContract, setOpenMallContract] = useState(false);
  const [openProductsContract, setOpenProductsContract] = useState(false);
  const [openConciergeContract, setOpenConciergeContract] = useState(false);

  const [productLink, setProductLink] = useState('');
  const [linkLoading, setLinkLoading] = useState(false);
  const [linkConfirmed, setLinkConfirmed] = useState(false);

  const [agreementMall, setAgreementMall] = useState('');
  const [agreementProducts, setAgreementProducts] = useState('');
  const [agreementConcierge, setAgreementConcierge] = useState('');

  const [ipAddress, setIpAddress] = useState('');
  const [isButtonActive, setIsButtonActive] = useState(true);

  const [branchCurrentEasyMallSetting, setBranchCurrentEasyMallSetting] =
    useState();
  const [url, setUrl] = useState('');

  const [branchTitle, setBranchTitle] = useState('');
  const [mallTitle, setMallTitle] = useState('');
  const hasFetchedRef = useRef(false);
  const hasFetchedAgreementsRef = useRef(false);

  const handleConciergeSwitchChange = (event) => {
    if (event.target.checked) {
      setConciergeActive(true);
      let easyMallSettings = {
        systemStatus: {
          agreementAcceptDateTime:
            branchCurrentEasyMallSetting.systemStatus.agreementAcceptDateTime,
          status: branchCurrentEasyMallSetting.systemStatus.status,
          ip: branchCurrentEasyMallSetting.systemStatus.ip,
          userID: branchCurrentEasyMallSetting.systemStatus.userID,
          url: branchCurrentEasyMallSetting.systemStatus.url,
        },
        conciergeStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: true,
          ip: ipAddress,
          userID: parsedUser.userID,
        },
      };

      Services.UpdateBranch(
        parsedUser.token,
        easyMallSettings,
        parsedUser.branchID
      ).then((res) => {
        setIsButtonActive(true);
        if (res.data.status) {
          toast.success('İşleminiz başarıyla tamamlandı');
          getBranch();
        } else {
          toast.error('Kaydetme sırasında bir hatayla karşılaşıldı');
        }
      });
    } else {
      setConciergeActive(false);
      let easyMallSettings = {
        systemStatus: {
          agreementAcceptDateTime:
            branchCurrentEasyMallSetting.systemStatus.agreementAcceptDateTime,
          status: branchCurrentEasyMallSetting.systemStatus.status,
          ip: branchCurrentEasyMallSetting.systemStatus.ip,
          userID: branchCurrentEasyMallSetting.systemStatus.userID,
          url: branchCurrentEasyMallSetting.systemStatus.url,
        },
        conciergeStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: false,
          ip: ipAddress,
          userID: parsedUser.userID,
        },
      };

      Services.UpdateBranch(
        parsedUser.token,
        easyMallSettings,
        parsedUser.branchID
      ).then((res) => {
        setIsButtonActive(true);
        if (res.data.status) {
          toast.success('İşleminiz başarıyla tamamlandı');
          getBranch();
        } else {
          toast.error('Kaydetme sırasında bir hatayla karşılaşıldı');
        }
      });
    }
  };

  const handleMallSwitchChange = (event) => {
    if (event.target.checked) {
      setOpenMallContract(true);
    } else {
      setMallActive(false);
      setConciergeActive(false);

      let easyMallSettings = {
        systemStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: false,
          ip: ipAddress,
          userID: parsedUser.userID,
          url: url,
        },
        conciergeStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: false,
          ip: ipAddress,
          userID: parsedUser.userID,
        },
      };

      Services.UpdateBranch(
        parsedUser.token,
        easyMallSettings,
        parsedUser.branchID
      ).then((res) => {
        setIsButtonActive(true);
        if (res.data.status) {
          toast.success('İşleminiz başarıyla tamamlandı');
          getBranch();
        } else {
          toast.error('Kaydetme sırasında bir hatayla karşılaşıldı');
        }
      });
    }
  };

  const confirmMallContract = () => {
    setMallActive(true);
    setOpenMallContract(false);

    let easyMallSettings;

    if (!branchCurrentEasyMallSetting) {
      easyMallSettings = {
        systemStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: true,
          ip: ipAddress,
          userID: parsedUser.userID,
          url: url,
        },
        conciergeStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: isConciergeActive,
          ip: ipAddress,
          userID: parsedUser.userID,
        },
      };
    } else {
      easyMallSettings = {
        systemStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: true,
          ip: ipAddress,
          userID: parsedUser.userID,
          url: url,
        },
        conciergeStatus: {
          agreementAcceptDateTime:
            branchCurrentEasyMallSetting.conciergeStatus
              .agreementAcceptDateTime,
          status: branchCurrentEasyMallSetting.conciergeStatus.status,
          ip: branchCurrentEasyMallSetting.conciergeStatus.ip,
          userID: branchCurrentEasyMallSetting.conciergeStatus.userID,
        },
      };
    }

    Services.UpdateBranch(
      parsedUser.token,
      easyMallSettings,
      parsedUser.branchID
    ).then((res) => {
      setIsButtonActive(true);
      if (res.data.status) {
        toast.success('İşleminiz başarıyla tamamlandı');
        getBranch();
      } else {
        toast.error('Kaydetme sırasında bir hatayla karşılaşıldı');
      }
    });
  };

  const cancelMallContract = () => {
    setMallActive(false);
    setOpenMallContract(false);
  };

  const handleProductsSwitchChange = (event) => {
    if (event.target.checked) {
      setOpenProductsContract(true);
    } else {
      resetProductLink();
      setProductsListed(false);
    }
  };

  const resetProductLink = () => {
    setProductLink('');
    setLinkLoading(false);
    setLinkConfirmed(false);
  };

  const cancelProductsContract = () => {
    resetProductLink();
    setProductsListed(false);
    setOpenProductsContract(false);
  };

  const handleProductLinkSubmit = () => {
    if (productLink.trim() === '') return;
    setLinkLoading(true);
    setLinkConfirmed(false);
    setTimeout(() => {
      setLinkLoading(false);
      setLinkConfirmed(true);
    }, 1500);
  };

  const confirmProductsContract = () => {
    if (linkConfirmed) {
      setProductsListed(true);
      setOpenProductsContract(false);
    }
  };

  const confirmConciergeContract = () => {
    setConciergeActive(true);
    setOpenConciergeContract(false);
  };

  const cancelConciergeContract = () => {
    setConciergeActive(false);
    setOpenConciergeContract(false);
  };

  const getBranch = () => {
    Services.GetBranch(parsedUser.token, parsedUser.branchID).then((res) => {
      setBranchTitle(res.data.result.title);
      setMallTitle(res.data.result.mall.title);

      setBranchCurrentEasyMallSetting(res.data.result.easyMallSettings);

      setUrl(res.data.result.easyMallSettings.systemStatus.url);
      setMallActive(
        res.data.result.easyMallSettings.systemStatus.status
          ? res.data.result.easyMallSettings.systemStatus.status
          : false
      );
      setConciergeActive(
        res.data.result.easyMallSettings.conciergeStatus.status
          ? res.data.result.easyMallSettings.conciergeStatus.status
          : false
      );
    });
  };

  const getMyIP = () => {
    Services.WhatIsMyIP(parsedUser.token).then((res) => {
      setIpAddress(res.data.result);
    });
  };

  const handleSave = () => {
    setIsButtonActive(false);
    let easyMallSettings;

    if (!branchCurrentEasyMallSetting) {
      easyMallSettings = {
        systemStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: isMallActive,
          ip: ipAddress,
          userID: parsedUser.userID,
          url: url,
        },
        conciergeStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: isConciergeActive,
          ip: ipAddress,
          userID: parsedUser.userID,
        },
      };
    } else if (
      branchCurrentEasyMallSetting.systemStatus.status !== isMallActive &&
      branchCurrentEasyMallSetting.conciergeStatus.status === isConciergeActive
    ) {
      easyMallSettings = {
        systemStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: isMallActive,
          ip: ipAddress,
          userID: parsedUser.userID,
          url: url,
        },
        conciergeStatus: {
          agreementAcceptDateTime:
            branchCurrentEasyMallSetting.conciergeStatus
              .agreementAcceptDateTime,
          status: branchCurrentEasyMallSetting.conciergeStatus.status,
          ip: branchCurrentEasyMallSetting.conciergeStatus.ip,
          userID: branchCurrentEasyMallSetting.conciergeStatus.userID,
        },
      };
    } else if (
      branchCurrentEasyMallSetting.systemStatus.status === isMallActive &&
      branchCurrentEasyMallSetting.conciergeStatus.status !== isConciergeActive
    ) {
      easyMallSettings = {
        systemStatus: {
          agreementAcceptDateTime:
            branchCurrentEasyMallSetting.systemStatus.agreementAcceptDateTime,
          status: branchCurrentEasyMallSetting.systemStatus.status,
          ip: branchCurrentEasyMallSetting.systemStatus.ip,
          userID: branchCurrentEasyMallSetting.systemStatus.userID,
          url: branchCurrentEasyMallSetting.systemStatus.url,
        },
        conciergeStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: isConciergeActive,
          ip: ipAddress,
          userID: parsedUser.userID,
        },
      };
    } else if (
      branchCurrentEasyMallSetting.systemStatus.status !== isMallActive &&
      branchCurrentEasyMallSetting.conciergeStatus.status !== isConciergeActive
    ) {
      easyMallSettings = {
        systemStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: isMallActive,
          ip: ipAddress,
          userID: parsedUser.userID,
          url: url,
        },
        conciergeStatus: {
          agreementAcceptDateTime: Math.floor(Date.now() / 1000),
          status: isConciergeActive,
          ip: ipAddress,
          userID: parsedUser.userID,
        },
      };
    } else if (
      branchCurrentEasyMallSetting.systemStatus.status === isMallActive &&
      branchCurrentEasyMallSetting.conciergeStatus.status === isConciergeActive
    ) {
      easyMallSettings = {
        systemStatus: {
          agreementAcceptDateTime:
            branchCurrentEasyMallSetting.systemStatus.agreementAcceptDateTime,
          status: branchCurrentEasyMallSetting.systemStatus.status,
          ip: branchCurrentEasyMallSetting.systemStatus.ip,
          userID: branchCurrentEasyMallSetting.systemStatus.userID,
          url: branchCurrentEasyMallSetting.systemStatus.url,
        },
        conciergeStatus: {
          agreementAcceptDateTime:
            branchCurrentEasyMallSetting.conciergeStatus
              .agreementAcceptDateTime,
          status: branchCurrentEasyMallSetting.conciergeStatus.status,
          ip: branchCurrentEasyMallSetting.conciergeStatus.ip,
          userID: branchCurrentEasyMallSetting.conciergeStatus.userID,
        },
      };
    }

    Services.UpdateBranch(
      parsedUser.token,
      easyMallSettings,
      parsedUser.branchID
    ).then((res) => {
      setIsButtonActive(true);
      if (res.data.status) {
        toast.success('İşleminiz başarıyla tamamlandı');
        getBranch();
      } else {
        toast.error('Kaydetme sırasında bir hatayla karşılaşıldı');
      }
    });
  };

  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    getBranch();
    getMyIP();
  }, []);

  function isValidHttpsURL(string) {
    try {
      const url = new URL(string);
      return url.protocol === 'https:';
    } catch (_) {
      return false;
    }
  }

  useEffect(() => {
    if (hasFetchedAgreementsRef.current) return;
    hasFetchedAgreementsRef.current = true;

    const fetchAgreements = async () => {
      try {
        const mallRes = await Services.GetAgreement(
          parsedUser.token,
          'easy-mall-01'
        );
        setAgreementMall(mallRes.data.result.description);
        const productsRes = await Services.GetAgreement(
          parsedUser.token,
          'easy-mall-02'
        );
        setAgreementProducts(productsRes.data.result.description);
        const conciergeRes = await Services.GetAgreement(
          parsedUser.token,
          'easy-mall-03'
        );
        setAgreementConcierge(conciergeRes.data.result.description);
      } catch (error) {
        console.error('Sözleşmeler çekilirken hata oluştu:', error);
      }
    };
    fetchAgreements();
  }, [parsedUser.token]);

  const slugify = (text) => {
    return text
      .toLowerCase()
      .replace(/ç/g, 'c')
      .replace(/ğ/g, 'g')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ş/g, 's')
      .replace(/ü/g, 'u')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const handleCopy = () => {
    setUrl(
      'https://easymall.com.tr/urunler/' +
        slugify(mallTitle) +
        '/' +
        slugify(branchTitle)
    );
    navigator.clipboard
      .writeText(
        'https://easymall.com.tr/urunler/' +
          slugify(mallTitle) +
          '/' +
          slugify(branchTitle)
      )
      .then(() => {
        toast.success('Link kopyalandı.');
      })
      .catch((err) => {
        console.error('Şifre kopyalanırken bir hata oluştu:', err);
      });
  };

  return (
    <>
      <Helmet>
        <title> Easy Mall | Mall Logistics Panel</title>
      </Helmet>
      <Stack sx={{ paddingInline: '25px' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Easy Mall
          </Typography>
        </Stack>

        <Card sx={{ padding: '20px', width: '50%' }}>
          <Stack spacing={2}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography>
                Easy Mall Sistemini Aktif Et ve Ürünleri Listele
              </Typography>
              <Switch
                checked={isMallActive}
                onChange={handleMallSwitchChange}
              />
            </Stack>

            {/* <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Typography style={{flexDirection:'row',display:'flex'}}>Easy Mall Sisteminde Ürünlerimi Listele {linkConfirmed && <span style={{flexDirection:'row',display:'flex',marginLeft:'3px',gap:'5px'}}><Typography color={"#54D62C"}> - Link bağlı</Typography> <CheckCircleIcon color="success" /></span> }</Typography>
                            <Switch checked={isProductsListed} onChange={handleProductsSwitchChange} />
                        </Stack> */}

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography>Easy Mall Concierge Sistemini Aktif Et</Typography>
              <Switch
                disabled={!isMallActive}
                checked={isConciergeActive}
                onChange={handleConciergeSwitchChange}
              />
            </Stack>
          </Stack>
        </Card>

        <Dialog open={openMallContract} onClose={cancelMallContract}>
          <DialogTitle>
            Sözleşme - Easy Mall Sistemi Aktif Etme ve Ürünleri Listeleme
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              {agreementMall ? (
                <div dangerouslySetInnerHTML={{ __html: agreementMall }} />
              ) : (
                'Sözleşme yükleniyor...'
              )}
            </Typography>
          </DialogContent>

          <div
            style={{
              width: '90%',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              marginLeft: '5%',
              marginTop: '25px',
              fontSize: '14px',
              flexDirection: 'column',
            }}
          >
            <span>
              Ürünlerin yüklenebilmesi için lütfen Mağazanızın Google Feed’ini
              veya{' '}
              <span
                onClick={handleCopy}
                style={{
                  textDecoration: 'underline',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}
              >
                {'https://easymall.com.tr/urunler/' +
                  slugify(mallTitle) +
                  '/' +
                  slugify(branchTitle)}
              </span>{' '}
              <ContentCopyIcon
                onClick={handleCopy}
                style={{ width: '14px', height: '14px', cursor: 'pointer' }}
                color="action"
              />{' '}
              linkini giriniz.
            </span>
            <TextField
              sx={{ marginTop: '15px', width: '100%' }}
              label="Linki Giriniz"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
          </div>

          <DialogActions
            sx={{
              width: '90%',
              marginLeft: '5%',
              paddingInline: 0,
              marginTop: '15px',
            }}
          >
            <Button onClick={cancelMallContract}>İptal</Button>
            <Button
              disabled={!isValidHttpsURL(url)}
              onClick={confirmMallContract}
              variant="contained"
            >
              Onayla
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openProductsContract} onClose={cancelProductsContract}>
          <DialogTitle>Sözleşme - Ürünlerimin Listelenmesi</DialogTitle>
          <DialogContent>
            <Typography variant="body1" gutterBottom>
              {agreementProducts ? (
                <div dangerouslySetInnerHTML={{ __html: agreementProducts }} />
              ) : (
                'Sözleşme yükleniyor...'
              )}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={2}>
              <TextField
                label="Ürün Linki"
                fullWidth
                value={productLink}
                onChange={(e) => setProductLink(e.target.value)}
                disabled={linkLoading || linkConfirmed}
              />
              <Button
                variant="outlined"
                onClick={handleProductLinkSubmit}
                disabled={
                  linkLoading || productLink.trim() === '' || linkConfirmed
                }
              >
                Bağla
              </Button>
              {linkLoading && <CircularProgress size={24} />}
              {linkConfirmed && <CheckCircleIcon color="success" />}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={cancelProductsContract}>İptal</Button>
            <Button
              onClick={confirmProductsContract}
              variant="contained"
              disabled={!linkConfirmed}
            >
              Onayla
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openConciergeContract} onClose={cancelConciergeContract}>
          <DialogTitle>Sözleşme - Concierge Sistemi Aktif Etme</DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              {agreementConcierge ? (
                <div dangerouslySetInnerHTML={{ __html: agreementConcierge }} />
              ) : (
                'Sözleşme yükleniyor...'
              )}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={cancelConciergeContract}>İptal</Button>
            <Button onClick={confirmConciergeContract} variant="contained">
              Onayla
            </Button>
          </DialogActions>
        </Dialog>
      </Stack>
    </>
  );
}
